<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part-001"><a id="page_25">
<div class="part_debut"></div>
<h1 class="part_n"><span>P<span class="small">ART</span> O<span class="small">NE</span><br/><br/>
<img alt="image" class="imagelarge_intext" id="sep_2" src="images/sep.jpg"/></span></h1>
<h1 class="part_tit"><span>A<span class="small">N</span> A<span class="small">GEIST</span> Z<span class="small">EITGEIST</span></span></h1>
</a></div><a id="page_25">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1.vue?1ef4b0fc